import React, { useEffect, useState } from "react";
import { Col, Row, Modal, ModalBody, Input, Label } from "reactstrap";
import { Link } from "react-router-dom";

//Job Images
import jobImage1 from "../../../assets/images/featured-job/img-01.png";
import jobImage2 from "../../../assets/images/featured-job/img-02.png";
import jobImage3 from "../../../assets/images/featured-job/img-03.png";
import { get } from "../../../utils/apiUtil";

const JobVacancyPost = ({ onApplyClick }) => {
    const [modal, setModal] = useState(false);
    const openModal = () => setModal(!modal);

    const [isLoading, setIsLoading] = useState(false);
    const [jobDetails, setJobDetails] = useState([]);

    const getAllJobs = async () => {
        setIsLoading(true);
        try {
            const response = await get('/get-all-jobs');
            setJobDetails(response.data);
        } catch (error) {
            console.log(error)
            alert(error?.message || "Something went wrong.");
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getAllJobs();
    }, []);

    const fallbackImage = "https://t4.ftcdn.net/jpg/06/71/92/37/360_F_671923740_x0zOL3OIuUAnSF6sr7PuznCI5bQFKhI0.jpg";
    const jobVacancyPost = jobDetails.map((job) => ({
        id: job.ID,
        companyImg: job.CompanyLogo || fallbackImage,
        jobDescription: job.JobTitle,
        experience: job.ExperienceRequired || "N/A",
        companyName: job.CompanyName || "Unknown Company",
        location: job.JobLocation || "Not specified",
        salary: job.OfferSalary,
        fullTime: job.EmployeeType?.toLowerCase().includes("full"),
        partTime: job.EmployeeType?.toLowerCase().includes("part"),
        freeLance: job.EmployeeType?.toLowerCase().includes("freelance"),
        timing: job.EmployeeType,
        addclassNameBookmark: false,
        badges: [
            {
                id: 1,
                badgeclassName: "bg-danger-subtle text-danger",
                badgeName: job.PositionLevel || "N/A"
            },
            {
                id: 2,
                badgeclassName: "bg-secondary-subtle text-secondary",
                badgeName: job.Rating ? `Rating: ${job.Rating}` : "Not Rated"
            }
        ],
        skillTags: job.SkillTags.split("|") || [],
    }));


    return (
        <React.Fragment>
            {jobVacancyPost.slice(0, 3).map((jobVacancyPostDetails, key) => (
                <div
                    key={key}
                    className={
                        jobVacancyPostDetails.addclassNameBookmark === true
                            ? "job-box bookmark-post card mt-4"
                            : "job-box card mt-4"
                    }
                >
                    <div className="p-4">
                        <Row>
                            <Col lg={2}>
                                <Link to="/companydetails">
                                    <img
                                        src={jobVacancyPostDetails.companyImg}
                                        alt=""
                                        className="img-fluid rounded-3"
                                        draggable={false}
                                    />
                                </Link>
                            </Col>
                            <Col lg={9}>
                                <div className="mt-3 mt-lg-0">
                                    <h5 className="fs-17 mb-1">
                                        <Link to={`/job-details/${jobVacancyPostDetails.id}`} className="text-dark">
                                            {jobVacancyPostDetails.jobDescription}
                                        </Link>{" "}
                                        <small className="text-muted fw-normal">
                                            ({jobVacancyPostDetails.experience})
                                        </small>
                                    </h5>
                                    <ul className="list-inline mb-0">
                                        <li className="list-inline-item">
                                            <p className="text-muted fs-14 mb-0">
                                                {jobVacancyPostDetails.companyName}
                                            </p>
                                        </li>
                                        <li className="list-inline-item">
                                            <p className="text-muted fs-14 mb-0">
                                                <i className="mdi mdi-map-marker"></i>
                                                {jobVacancyPostDetails.location}
                                            </p>
                                        </li>
                                        <li className="list-inline-item">
                                            <p className="text-muted fs-14 mb-0">
                                                <i className="uil uil-wallet"></i>{" "}
                                                {jobVacancyPostDetails.salary}
                                            </p>
                                        </li>
                                    </ul>
                                    <div className="mt-2">
                                        <span
                                            className={
                                                jobVacancyPostDetails.timing === "Freelance"
                                                    ? "badge bg-primary-subtle text-primary fs-13 mt-1 mx-1"
                                                    : "badge bg-info-subtle text-info fs-13 mt-1 mx-1"
                                            }
                                        >
                                            {jobVacancyPostDetails.timing}
                                        </span>
                                        {(jobVacancyPostDetails.badges || []).map(
                                            (badgeInner, key) => (
                                                <span
                                                    className={`badge ${badgeInner.badgeclassName} fs-13 mt-1 mx-1`}
                                                    key={key}
                                                >
                                                    {badgeInner.badgeName}
                                                </span>
                                            )
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <div className="favorite-icon">
                            <Link to="#">
                                <i className="uil uil-heart-alt fs-18"></i>
                            </Link>
                        </div>
                    </div>
                    <div className="p-3 bg-light">
                        <div className="row justify-content-between">
                            <Col md={8}>
                                <div>
                                    <ul className="list-inline mb-0">
                                        <li className="list-inline-item">
                                            <i className="uil uil-tag"></i> Keywords:
                                        </li>
                                        {(jobVacancyPostDetails.skillTags || []).map(
                                            (badgeInner, key) => (
                                                <Link to="#" className="primary-link text-muted" key={key}>
                                                    {badgeInner}, {" "}
                                                </Link>
                                            )
                                        )}
                                    </ul>
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className="text-md-end">
                                    <Link
                                        to="#"
                                        onClick={() => onApplyClick(jobVacancyPostDetails)}
                                        className="primary-link"
                                    >
                                        Apply Now <i className="mdi mdi-chevron-double-right"></i>
                                    </Link>
                                </div>
                            </Col>
                        </div>
                    </div>
                </div>
            ))}

            <div className="text-center mt-4">
                <Link to="/all-jobs" className="primary-link form-text">
                    View more <i className="mdi mdi-arrow-right"></i>
                </Link>
            </div>

            <div
                className="modal fade"
                id="applyNow"
                tabIndex="-1"
                aria-labelledby="applyNow"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <Modal isOpen={modal} toggle={openModal} centered>
                        <ModalBody className="modal-body p-5">
                            <div className="text-center mb-4">
                                <h5 className="modal-title" id="staticBackdropLabel">
                                    Apply For This Job
                                </h5>
                            </div>
                            <div className="position-absolute end-0 top-0 p-3">
                                <button
                                    type="button"
                                    onClick={openModal}
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="mb-3">
                                <Label for="nameControlInput" className="form-label">
                                    Name
                                </Label>
                                <Input
                                    type="text"
                                    className="form-control"
                                    id="nameControlInput"
                                    placeholder="Enter your name"
                                />
                            </div>
                            <div className="mb-3">
                                <Label for="emailControlInput2" className="form-label">
                                    Email Address
                                </Label>
                                <Input
                                    type="email"
                                    className="form-control"
                                    id="emailControlInput2"
                                    placeholder="Enter your email"
                                />
                            </div>
                            <div className="mb-3">
                                <Label for="messageControlTextarea" className="form-label">
                                    Message
                                </Label>
                                <textarea
                                    className="form-control"
                                    id="messageControlTextarea"
                                    rows="4"
                                    placeholder="Enter your message"
                                ></textarea>
                            </div>
                            <div className="mb-4">
                                <Label className="form-label" for="inputGroupFile01">
                                    Resume Upload
                                </Label>
                                <Input
                                    type="file"
                                    className="form-control"
                                    id="inputGroupFile01"
                                />
                            </div>
                            <button type="submit" className="btn btn-primary w-100">
                                Send Application
                            </button>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
        </React.Fragment>
    );
};

export default JobVacancyPost;
